
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-[#F8F6F3]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-sm tracking-widest text-[#C9A961] uppercase">
              About the Author
            </span>
            <h1 className="font-serif text-6xl text-[#2C2C2C] mt-4 mb-6">
              Edward J. Dumke
            </h1>
            <p className="text-xl text-[#666666] leading-relaxed">
              Chronicling the heart and soul of San Francisco through compelling family sagas
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="space-y-8">
              <div>
                <h2 className="font-serif text-4xl text-[#2C2C2C] mb-6 text-center">
                  A Lifelong Love Affair with San Francisco
                </h2>
                <p className="text-lg text-[#666666] leading-relaxed mb-6">
                  Edward Dumke, a native of the San Francisco Bay Area, has always held a 
                  deep fascination for the City by the Bay. For over sixty years he has been 
                  a keen observer of the San Francisco scene with all its unparalleled beauty, 
                  diversity, and rich cultural heritage.
                </p>
                <p className="text-lg text-[#666666] leading-relaxed mb-6">
                  His novels are deeply rooted in the unique character of San Francisco, 
                  weaving together the city's iconic landmarks, colorful history, and diverse 
                  communities into compelling narratives that span generations. Through his 
                  writing, Edward brings to life the stories of families navigating the 
                  complexities of love, loss, and legacy against the backdrop of one of 
                  America's most beloved cities.
                </p>
                <p className="text-lg text-[#666666] leading-relaxed">
                  With a keen eye for historical detail and a gift for creating authentic, 
                  multi-dimensional characters, Edward crafts family sagas that resonate with 
                  readers who appreciate richly textured storytelling. His work explores the 
                  hidden secrets that shape families across time, the enduring bonds that 
                  connect us to our past, and the universal truths that define the human 
                  experience.
                </p>
              </div>

              <div className="border-l-4 border-[#C9A961] pl-6 py-4 my-12">
                <p className="font-serif italic text-2xl text-[#2C2C2C] leading-relaxed">
                  "Every family has secrets. Some are meant to protect, others to conceal. 
                  But all of them, eventually, demand to be told."
                </p>
                <p className="text-sm text-[#C9A961] mt-4">— Edward J. Dumke</p>
              </div>

              <div>
                <h3 className="font-serif text-3xl text-[#2C2C2C] mb-6 text-center">
                  Writing Philosophy
                </h3>
                <p className="text-lg text-[#666666] leading-relaxed mb-6">
                  Edward believes that the best stories are those that illuminate the 
                  connections between past and present, showing how the choices of one 
                  generation ripple through time to shape the lives of those who follow. 
                  His approach to writing combines meticulous historical research with 
                  deeply personal character development, creating narratives that feel 
                  both authentic and emotionally resonant.
                </p>
                <p className="text-lg text-[#666666] leading-relaxed">
                  When he's not writing, Edward can be found exploring San Francisco's 
                  neighborhoods, researching historical archives, or enjoying the city's 
                  vibrant cultural scene. He continues to draw inspiration from the ever-
                  changing yet timeless character of the City by the Bay.
                </p>
              </div>

              <div className="bg-[#F8F6F3] rounded-2xl p-8 mt-12">
                <h3 className="font-serif text-2xl text-[#2C2C2C] mb-6 text-center">
                  Published Works
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-4">
                    <div className="w-2 h-2 bg-[#C9A961] rounded-full mt-2"></div>
                    <div>
                      <h4 className="font-semibold text-[#2C2C2C] mb-1">
                        Family Secrets: A San Francisco Saga
                      </h4>
                      <p className="text-sm text-[#666666]">
                        A multi-generational tale of love, betrayal, and redemption
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-2 h-2 bg-[#C9A961] rounded-full mt-2"></div>
                    <div>
                      <h4 className="font-semibold text-[#2C2C2C] mb-1">
                        The Serpent Beguiled Me And I Ate
                      </h4>
                      <p className="text-sm text-[#666666]">
                        A compelling exploration of temptation and consequence
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
